// Ejemplo de TransportSelector modificado:
import React from 'react';
import PropTypes from 'prop-types';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftSelect from 'components/SoftSelect';

const TransportSelector = ({ selectedTransport, setSelectedTransport }) => {
  // Define las opciones con un valor numérico (por ejemplo, TERRESTRE=1, MARÍTIMO=2, AÉREO=3)
  const transportOptions = [
    { label: 'TERRESTRE', value: 1 },
    { label: 'MARÍTIMO', value: 2 },
    { label: 'AÉREO', value: 3 },
  ];

  return (
    <SoftBox>
      <SoftTypography variant="caption" fontWeight="bold" color="text">
        Tipo de Transporte
      </SoftTypography>
      <SoftSelect
        options={transportOptions}
        value={transportOptions.find(option => option.value === selectedTransport)}
        onChange={(option) => setSelectedTransport(option ? option.value : null)}
        placeholder="Seleccione un tipo de transporte"
      />
    </SoftBox>
  );
};

TransportSelector.propTypes = {
  selectedTransport: PropTypes.number, // Ahora se espera un número
  setSelectedTransport: PropTypes.func.isRequired,
};

export default TransportSelector;
